// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"27c525a1","689":"27c525a1","758":"8f2d4b9e"}[chunkId] + ".chunk.css";
};